import { SSRBannerManager } from '../src/SSRBannerManager';

export const ssrBannerManager = new SSRBannerManager();
